(function (angular, app) {
   "use strict";

   angular.module(app.modules.view.name)
      .controller(app.modules.view.routes.invalid.controller, InvalidController);
      
   InvalidController.$inject = [app.modules.common.services.functions];
   
   function InvalidController(appFunctions) {
            
      // Assign this to object so it can be updated from watcher
      var ctrl = this;
   
      // Close View
      ctrl.closePage = function(){
         appFunctions.goToPage(app.modules.view.routes.intro.path);
      };

   }
}(angular, app));

